module.exports = __webpack_public_path__ + "img/dropdown.8499a46a.svg";